import { type Config } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/whiteLabelConfig/Config";
import { type ConfigRepositoryInterface } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/whiteLabelConfig/ConfigRepositoryInterface";
import axios from "axios";

const BASE_URL = import.meta.env.VITE_APP_API;
const ENDPOINT = "/white-label/config";

const configRepository: ConfigRepositoryInterface = {
  async get() {
    let response;
    try {
      response = await axios.get(ENDPOINT, { baseURL: BASE_URL });
      if (response.status !== 200) {
        throw new Error(`Received status code "${response.status}" is not 200`);
      }
    } catch (err) {
      // @ts-expect-error : will fixed automatically with vite and ESnext (The constructor overload with cause is only supported with ES2022 or later)
      throw new Error("Failed to get WhiteLabelConfig", { cause: err });
    }

    const {
      tagManagerId,
      axeptioId,
      externalWebsiteLink,
      dropOffLocationsMapEnabled,
      cookiesPolicy,
      accessibilityStatement,
    } = response.data;
    const config: Config = {
      tagManagerId,
      axeptioId,
      externalWebsiteLink: {
        active: externalWebsiteLink !== null,
        url: externalWebsiteLink?.url,
        text: externalWebsiteLink?.text,
      },
      dropOffLocationsMapEnabled,
      cookiesPolicy,
      accessibilityStatement,
    };

    return Object.freeze(config);
  },
};

export default configRepository;
